const ConditionComponent = ({ condition, renderElement, otherwiseElement = null }) =>
  condition ? renderElement : otherwiseElement;

export default ConditionComponent;
